<template>
  <div class="home-custom-icon">
    <img class="home-custom-icon__svg" :src="logoPath" alt="" loading="lazy" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import CloudFrontUtil from '@/util/aws/CloudFrontUtil'

export default defineComponent({
  name: 'HomeCustomIcon',
  props: {
    /**
     * Homeアイコンのパス
     */
    iconPath: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    /** ロゴのパス */
    const logoPath = computed(() => CloudFrontUtil.getSignedUrl(props.iconPath))

    return {
      logoPath,
    }
  },
})
</script>

<style scoped lang="scss">
.home-custom-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  &__svg {
    width: 100%;
    height: auto;
  }
}
</style>
